import slug from "slug";

export function toSlug(str: string) {
  return slug(str);
}

export function positionToPlace(value: number) {
  if (value < 0) {
    return "?";
  }

  const inHundred = value % 100;
  let suffix = "th";
  if (inHundred < 10 || inHundred > 20) {
    const inTen = inHundred % 10;
    switch (inTen) {
      case 3:
        suffix = "rd";
        break;
      case 2:
        suffix = "nd";
        break;
      case 1:
        suffix = "st";
        break;
    }
  }
  return value + suffix;
}

export const removeTrailingSlash = (string: string = "") => {
  if (string.length > 1 && string.endsWith("/")) {
    return string.replace(/\/+$/, "");
  }

  return string;
};

export const normalizePrizeValue = (prize: number | string): number => {
  if (typeof prize === "string") {
    return Number(prize.replace(/[^\d.-]/g, "")) || 0;
  }
  return prize;
};
